import { UpdateAppVersionOutput } from "../domain/update-app-version.output"

export class UpdateAppVersionApiRepository implements UpdateAppVersionOutput {
	updateAppVersion(version: string): void {
		localStorage.setItem("app-version", version)
	}
}
